import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService from 'services/dataService';
import { apiCompleteTask } from 'services/dataService/resources/oneplatform/api';

import { getTasksByPatientQueryKey } from './use-get-tasks-by-patient';

import type { ITaskCard, TaskApiError } from '../types';

export const useCompleteTask = (patientGuid: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (taskGuid: string) =>
      dataService.createOne<{ task: ITaskCard }>(apiCompleteTask(taskGuid), {}),
    onSuccess: () => {
      notificationController.success({
        message: t('tasksDrawer.completeSuccess'),
      });
      queryClient.invalidateQueries(getTasksByPatientQueryKey(patientGuid));
    },
    onError: (error: unknown) => {
      const apiError = error as TaskApiError;
      const status = apiError?.status;
      const serverMessage = apiError?.response?.data?.message;
      if (status === 409) {
        notificationController.error({
          message: serverMessage ?? t('tasksDrawer.completeError'),
        });
        queryClient.invalidateQueries(getTasksByPatientQueryKey(patientGuid));
      } else {
        notificationController.error({
          message: t('tasksDrawer.completeError'),
        });
      }
    },
  });
};
